module.exports = __webpack_public_path__ + "static/media/tammy.beb00771.jpeg";